import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { PlusOutlined } from "@ant-design/icons";

import { tableColumn } from 'utils';
import { TableList, ActionButton, DateTimeText } from 'components/common';
import { GroupValue } from 'components/blocks/Group';


const RecommendedGroupList = ({ router, columnList, defaultFilter, activeFilter, actions, recommendedGroup, groupId }) => {
  const defaultColumnList = ['recommended_group', 'sort', 'date_created', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    recommended_group: tableColumn('Рекомендуемая группа', 'recommended_group', {
      render: (val, item) => (<GroupValue detail={val} asLink={true} isBack={true} />),
      sorter: true,
    }),
    sort: tableColumn('Сортировка', 'sort', {
      sorter: true,
    }),
    date_created: tableColumn('Дата создания', 'date_created', {
      render: (val, item) => <DateTimeText date={val} />,
      width: 150,
      sorter: true,
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton detail={item} modelActions={actions.recommendedGroup} actions={[{ name: 'edit' }, { name: 'delete' }]} />
      ),
    }),
  };

  const [selected, setSelected] = useState([]);

  const onLoad = useCallback(
    ({ query, activeFilter }) => {
      if (activeFilter === undefined) {
        activeFilter = recommendedGroup.filter.activeFilter;
      }
      actions.recommendedGroup.listLoad({ query, activeFilter, locationChange: true });
      setSelected([]);
    },
    [recommendedGroup, actions, setSelected],
  );

  const add = () => {
    actions.recommendedGroup.showEditForm({
      show: true, 
      preventLoadDetail: true
    });
  };

  return (
    <TableList
      location={router.location}
      model={recommendedGroup}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={[
        <Button type="primary" icon={<PlusOutlined/>} onClick={add}>
          Добавить
        </Button>
      ]}
      showSearch={false}
      selected={selected}
      rowSelection={{
        selectedRowKeys: selected,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelected(selectedRowKeys.slice());
        },
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  recommendedGroup: state.recommendedGroup,
});

const mapDispatch = (dispatch) => ({
  actions: {
    recommendedGroup: dispatch.recommendedGroup,
  },
});

export default connect(mapState, mapDispatch)(RecommendedGroupList);
